export default __webpack_public_path__ + "static/media/DDS173.a05933de.png";